import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 1,
  style: {"color":"var(--ion-color-dark)"}
}
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 1,
  style: {"color":"var(--ion-color-dark)"}
}
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { key: 3 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { style: {"line-height":"1"} }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_accordion = _resolveComponent("ion-accordion")!
  const _component_ion_accordion_group = _resolveComponent("ion-accordion-group")!
  const _component_ion_card = _resolveComponent("ion-card")!

  return ($props.useAccordionView)
    ? (_openBlock(), _createBlock(_component_ion_accordion_group, {
        key: 0,
        value: $props.ev.userResponse?.attended == 'Yes' ? 'event' : null
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_accordion, {
            style: {"--min-height":"24px"},
            value: "event"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_item, {
                lines: "full",
                slot: "header"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, { style: {"padding-left":"28px"} }, {
                    default: _withCtx(() => [
                      ($props.showStudentFormsOnly)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
                            ($props.ev.classes || $props.ev.studentForms)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                                  _createElementVNode("b", null, _toDisplayString($props.ev.classes || $props.ev.studentForms), 1),
                                  _createTextVNode(" (" + _toDisplayString($props.ev.date) + ") [Roll call, feedback]", 1)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_3, [
                                  _createElementVNode("b", null, _toDisplayString($props.ev.date), 1),
                                  _cache[10] || (_cache[10] = _createTextVNode(" [Roll call, feedback]"))
                                ]))
                          ]))
                        : (_openBlock(), _createElementBlock("p", _hoisted_4, [
                            ($props.ev.formattedName)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  style: {"white-space":"pre-line"},
                                  innerHTML: $props.ev.formattedName
                                }, null, 8, _hoisted_5))
                              : (_openBlock(), _createElementBlock("b", _hoisted_6, _toDisplayString($props.ev.name), 1)),
                            ($props.ev.description)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_7, ": " + _toDisplayString($props.ev.description), 1))
                              : _createCommentVNode("", true),
                            _withDirectives(_createElementVNode("small", null, _cache[11] || (_cache[11] = [
                              _createTextVNode(" ("),
                              _createElementVNode("u", null, "Details", -1),
                              _createTextVNode(")")
                            ]), 512), [
                              [_vShow, $props.ev.serviceId]
                            ]),
                            ($props.ev.classes || $props.ev.studentForms)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_8, " (" + _toDisplayString($props.ev.classes || $props.ev.studentForms) + ")", 1))
                              : _createCommentVNode("", true)
                          ]))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_list, {
                class: "ion-text-center ion-no-padding",
                slot: "content"
              }, {
                default: _withCtx(() => [
                  ($props.ev.rollCallCode)
                    ? (_openBlock(), _createBlock(_component_ion_item, {
                        key: 0,
                        style: {"--min-height":"24px"},
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.openRollCallCodePrompt($props.ev)), ["stop"])),
                        color: "light",
                        lines: "full",
                        button: "",
                        detail: $props.ev.userResponse?.attended != 'Yes',
                        disabled: (!$props.user.isAdmin && !$setup.isSessionStarted($props.ev)) || $props.ev.userResponse?.attended == 'Yes'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            style: {"padding-left":"48px"},
                            slot: "start",
                            icon: $props.ev.userResponse?.attended == 'Yes' ? $setup.checkmarkCircle : $setup.alertCircle,
                            color: $props.ev.userResponse?.attended == 'Yes' ? 'success' : 'danger'
                          }, null, 8, ["icon", "color"]),
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => _cache[12] || (_cache[12] = [
                              _createElementVNode("h3", null, "Take attendance", -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["detail", "disabled"]))
                    : _createCommentVNode("", true),
                  ($props.ev.userResponse?.attended == 'Yes')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.anchorEventTasks.filter(t => t.anchorEventId == $props.ev.anchorEventId && t.showAfterAttended), (task) => {
                          return (_openBlock(), _createBlock(_component_ion_item, {
                            color: "light",
                            key: task.id,
                            lines: "full",
                            button: "",
                            detail: $setup.checkShowTaskDetailIcon(task, $props.ev),
                            onClick: _withModifiers(($event: any) => ($setup.checkOpenTaskModal(task, $props.ev)), ["stop"])
                          }, {
                            default: _withCtx(() => [
                              ($setup.isFormQuestionTask(task) && $setup.loadingUserFormResponses)
                                ? (_openBlock(), _createBlock(_component_ion_spinner, {
                                    key: 0,
                                    slot: "start"
                                  }))
                                : _createCommentVNode("", true),
                              ($setup.isFormQuestionTask(task) && !$setup.loadingUserFormResponses)
                                ? (_openBlock(), _createBlock(_component_ion_icon, {
                                    key: 1,
                                    style: {"padding-left":"48px"},
                                    slot: "start",
                                    icon: $setup.isSubmittedTaskForm(task, $props.ev) ? $setup.checkmarkCircle : $setup.alertCircle,
                                    color: $setup.isSubmittedTaskForm(task, $props.ev) ? 'success' : 'danger'
                                  }, null, 8, ["icon", "color"]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("h3", null, _toDisplayString(task.title), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["detail", "onClick"]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"]))
    : (_openBlock(), _createBlock(_component_ion_card, {
        key: 1,
        class: _normalizeClass(["event-card", { 'no-strip': $props.noStrip, 'unsubscribed-event': $props.ev.userResponse?.response == 'Unsubscribed' }]),
        button: "",
        onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (($props.showTeacherActions || $props.disableCardClick) ? null : $setup.openServiceModal($props.ev.serviceId, $props.ev)), ["stop"]))
      }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_ion_item, {
            lines: "none",
            class: _normalizeClass({ 'past-event': $setup.isPastEvent($props.ev) })
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_label, { class: "ion-text-wrap ion-no-margin" }, {
                default: _withCtx(() => [
                  ($props.showStudentFormsOnly && ($props.ev.classes || $props.ev.studentForms))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                        _createElementVNode("span", null, _toDisplayString($props.ev.classes || $props.ev.studentForms), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_11, [
                        ($props.ev.formattedName)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              style: {"white-space":"pre-line"},
                              innerHTML: $props.ev.formattedName
                            }, null, 8, _hoisted_12))
                          : (_openBlock(), _createElementBlock("b", _hoisted_13, _toDisplayString($props.ev.name), 1)),
                        ($props.ev.description)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, ": " + _toDisplayString($props.ev.description), 1))
                          : _createCommentVNode("", true),
                        _withDirectives(_createElementVNode("small", null, _cache[13] || (_cache[13] = [
                          _createTextVNode(" ("),
                          _createElementVNode("u", null, "Details", -1),
                          _createTextVNode(")")
                        ]), 512), [
                          [_vShow, $props.ev.serviceId]
                        ]),
                        ($props.ev.classes || $props.ev.studentForms)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, " (" + _toDisplayString($props.ev.classes || $props.ev.studentForms) + ")", 1))
                          : _createCommentVNode("", true)
                      ]))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["class"]), [
            [_vShow, !$props.hideEventDetails && !$props.hideEventName]
          ]),
          _createVNode(_component_ion_list, { class: "ion-no-padding" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", null, [
                _createVNode(_component_ion_item, {
                  lines: "full",
                  button: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, { class: "ion-text-wrap ion-no-margin" }, {
                      default: _withCtx(() => [
                        _createElementVNode("h2", null, [
                          ($props.ev.status == 'TBC')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, "[Tentative] "))
                            : _createCommentVNode("", true),
                          _createElementVNode("i", null, _toDisplayString($props.ev.formattedDateTime), 1),
                          ($props.ev.employerName)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, " (" + _toDisplayString($props.ev.employerName) + ")", 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("p", null, _toDisplayString($props.ev.mode == 'Online' ? 'Online' : `${$props.ev.venue || 'Campus'}`), 1),
                        _createElementVNode("p", _hoisted_18, [
                          _createElementVNode("small", null, _toDisplayString($props.ev.language), 1)
                        ]),
                        ($props.ev.remainingSeats != '')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_19, [
                              _createElementVNode("small", null, [
                                _createElementVNode("b", null, _toDisplayString(Math.max(0, $props.ev.remainingSeats)), 1),
                                _createTextVNode(" seat" + _toDisplayString($props.ev.remainingSeats > 1 ? 's' : '') + " left", 1)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                ($props.user.teacher && $props.showTeacherActions)
                  ? (_openBlock(), _createBlock(_component_ion_accordion_group, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_accordion, { style: {"--min-height":"24px"} }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_item, {
                              class: "teacher-actions-toggle-item",
                              lines: "full",
                              slot: "header",
                              style: {"--min-height":"24px","--background":"#800020"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                  default: _withCtx(() => _cache[14] || (_cache[14] = [
                                    _createElementVNode("p", { style: {"color":"#fff"} }, "For teachers / principals", -1)
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_list, {
                              class: "ion-no-padding",
                              slot: "content"
                            }, {
                              default: _withCtx(() => [
                                (!['jobEX'].includes($props.ev.group) && !$props.user.isSecondaryStudent && ($props.user.teacher || $props.user.isAdmin))
                                  ? (_openBlock(), _createBlock(_component_ion_item, {
                                      key: 0,
                                      color: "light",
                                      lines: "full",
                                      button: "",
                                      detail: "",
                                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ($setup.openStudentModal($props.ev)), ["stop"]))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => _cache[15] || (_cache[15] = [
                                            _createElementVNode("h3", null, [
                                              _createElementVNode("b", null, "Browse applicants / Nominate")
                                            ], -1)
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                ($props.user.teacher && $props.ev.serviceId)
                                  ? (_openBlock(), _createBlock(_component_ion_item, {
                                      key: 1,
                                      color: "light",
                                      lines: "full",
                                      button: "",
                                      detail: "",
                                      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => ($setup.openServiceModal($props.ev.serviceId, $props.ev)), ["stop"]))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, {
                                          slot: "start",
                                          icon: $setup.relatedTeacherResponse ? $setup.checkmarkCircle : $setup.alertCircle,
                                          color: $setup.relatedTeacherResponse ? 'success' : 'danger'
                                        }, null, 8, ["icon", "color"]),
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => _cache[16] || (_cache[16] = [
                                            _createElementVNode("h3", null, [
                                              _createElementVNode("b", null, "Indicate your choice")
                                            ], -1)
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], 512), [
                [_vShow, !$props.hideEventDetails]
              ]),
              _withDirectives(_createElementVNode("div", null, [
                ($props.ev.userResponse?.confirmed == 'Yes')
                  ? (_openBlock(), _createBlock(_component_ion_item, {
                      key: 0,
                      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (($props.user.teacher || $props.user.isAdmin) ? $setup.updateEventResponse($props.ev, 'No') : undefined), ["stop"])),
                      color: "success",
                      button: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          slot: "start",
                          icon: $setup.checkmarkCircle
                        }, null, 8, ["icon"]),
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => _cache[17] || (_cache[17] = [
                            _createTextVNode("Applied")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : (!['work-workshop-2'].includes($props.ev.anchorEventId))
                    ? (_openBlock(), _createBlock(_component_ion_item, {
                        key: 1,
                        onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => ($setup.updateEventResponse($props.ev, 'Yes')), ["stop"])),
                        color: "light",
                        button: "",
                        detail: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => _cache[18] || (_cache[18] = [
                              _createElementVNode("h3", null, "Apply", -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
              ], 512), [
                [_vShow, !$props.hideApplyButton && !['ABS', 'Others'].includes($props.ev.group)]
              ]),
              _withDirectives(_createVNode(_component_ion_item, {
                color: "danger",
                lines: "full",
                button: "",
                detail: "",
                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => ($setup.openTeacherModal($props.ev)), ["stop"]))
              }, {
                default: _withCtx(() => _cache[19] || (_cache[19] = [
                  _createTextVNode(" Invite 1 teacher to join ")
                ])),
                _: 1
              }, 512), [
                [_vShow, $props.ev.group == 'Teacher Event' && $props.ev.userResponse?.confirmed == 'Yes']
              ]),
              _withDirectives(_createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.anchorEventTasks.filter(t => t.anchorEventId == $props.ev.anchorEventId && !t.showAfterAttended && (!$setup.isFormQuestionTask || t.formQuestions.length > 0)), (task) => {
                  return (_openBlock(), _createBlock(_component_ion_item, {
                    key: task.id,
                    color: "light",
                    lines: "full",
                    button: "",
                    detail: $setup.checkShowTaskDetailIcon(task, $props.ev),
                    onClick: _withModifiers(($event: any) => ($setup.checkOpenTaskModal(task, $props.ev)), ["stop"])
                  }, {
                    default: _withCtx(() => [
                      ($setup.isFormQuestionTask(task) && $setup.loadingUserFormResponses)
                        ? (_openBlock(), _createBlock(_component_ion_spinner, {
                            key: 0,
                            slot: "start"
                          }))
                        : _createCommentVNode("", true),
                      ($setup.isFormQuestionTask(task) && !$setup.loadingUserFormResponses)
                        ? (_openBlock(), _createBlock(_component_ion_icon, {
                            key: 1,
                            slot: "start",
                            icon: $setup.isSubmittedTaskForm(task, $props.ev) ? $setup.checkmarkCircle : $setup.alertCircle,
                            color: $setup.isSubmittedTaskForm(task, $props.ev) ? 'success' : 'danger'
                          }, null, 8, ["icon", "color"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createElementVNode("h3", null, [
                            _createElementVNode("b", null, _toDisplayString(task.title), 1)
                          ]),
                          _createElementVNode("p", null, _toDisplayString(task.group), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["detail", "onClick"]))
                }), 128)),
                ($props.ev.mode == 'Online' && $props.ev.onlineMeetingLink)
                  ? (_openBlock(), _createBlock(_component_ion_item, {
                      key: 0,
                      color: "light",
                      lines: "full",
                      target: "_blank",
                      href: $props.ev.onlineMeetingLink,
                      button: "",
                      detail: "",
                      disabled: !$setup.isSessionStarted($props.ev)
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          slot: "start",
                          icon: $setup.logInOutline
                        }, null, 8, ["icon"]),
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => _cache[20] || (_cache[20] = [
                            _createElementVNode("h3", null, "Meeting link", -1),
                            _createElementVNode("small", null, "Will be enabled 60 minutes before session starts", -1)
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["href", "disabled"]))
                  : _createCommentVNode("", true),
                ($props.ev.rollCallCode)
                  ? (_openBlock(), _createBlock(_component_ion_item, {
                      key: 1,
                      onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => ($setup.openRollCallCodePrompt($props.ev)), ["stop"])),
                      color: "light",
                      lines: "full",
                      button: "",
                      detail: $props.ev.userResponse?.attended != 'Yes',
                      disabled: !$props.user.isAdmin && !$setup.isSessionStarted($props.ev)
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          slot: "start",
                          icon: $props.ev.userResponse?.attended == 'Yes' ? $setup.checkmarkCircle : $setup.alertCircle,
                          color: $props.ev.userResponse?.attended == 'Yes' ? 'success' : 'danger'
                        }, null, 8, ["icon", "color"]),
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => _cache[21] || (_cache[21] = [
                            _createElementVNode("h3", null, [
                              _createElementVNode("b", null, "Take attendance")
                            ], -1),
                            _createElementVNode("small", null, "Will be enabled after session starts", -1)
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["detail", "disabled"]))
                  : _createCommentVNode("", true),
                (['work-workshop-2'].includes($props.ev.anchorEventId))
                  ? (_openBlock(), _createBlock(_component_ion_item, {
                      key: 2,
                      color: "light",
                      lines: "full",
                      button: "",
                      detail: "",
                      onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => ($setup.openSessionStudentListModal($props.ev.id)), ["stop"]))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          slot: "start",
                          icon: $props.user.userUsers.some(uu => uu.sessionId == $props.ev.id) ? $setup.checkmarkCircle : $setup.alertCircle,
                          color: $props.user.userUsers.some(uu => uu.sessionId == $props.ev.id) ? 'success' : 'danger'
                        }, null, 8, ["icon", "color"]),
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => _cache[22] || (_cache[22] = [
                            _createElementVNode("h3", null, [
                              _createElementVNode("b", null, "Vote for best presenters")
                            ], -1),
                            _createElementVNode("small", null, "During Lesson", -1)
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (['work-campus-visit','work-workshop-2'].includes($props.ev.anchorEventId) && (['readonly', 'full'].includes($props.user.slp?.accessType || '')))
                  ? (_openBlock(), _createBlock(_component_ion_item, {
                      key: 3,
                      color: "light",
                      onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => ($setup.openSLPModal()), ["stop"])),
                      lines: "full",
                      button: "",
                      detail: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          slot: "start",
                          icon: $props.user.slp?.gpt ? $setup.checkmarkCircle : $setup.alertCircle,
                          color: $props.user.slp?.gpt ? 'success' : 'danger'
                        }, null, 8, ["icon", "color"]),
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => _cache[23] || (_cache[23] = [
                            _createElementVNode("h3", null, [
                              _createElementVNode("b", null, "AchieveSLP")
                            ], -1),
                            _createElementVNode("small", null, "During Lesson", -1)
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                ($props.ev.userResponse?.attended == 'Yes')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.anchorEventTasks.filter(t => t.anchorEventId == $props.ev.anchorEventId && t.showAfterAttended && t.group != 'After Lesson'), (task) => {
                        return (_openBlock(), _createBlock(_component_ion_item, {
                          key: task.id,
                          lines: "full",
                          button: "",
                          detail: $setup.checkShowTaskDetailIcon(task, $props.ev),
                          onClick: _withModifiers(($event: any) => ($setup.checkOpenTaskModal(task, $props.ev)), ["stop"]),
                          color: "light"
                        }, {
                          default: _withCtx(() => [
                            ($setup.isProfessionSurveyTask(task))
                              ? (_openBlock(), _createBlock(_component_ion_icon, {
                                  key: 0,
                                  slot: "start",
                                  icon: $setup.submittedProfessionResponses ? $setup.checkmarkCircle : $setup.alertCircle,
                                  color: $setup.submittedProfessionResponses ? 'success' : 'danger'
                                }, null, 8, ["icon", "color"]))
                              : _createCommentVNode("", true),
                            ($setup.isFormQuestionTask(task) && $setup.loadingUserFormResponses)
                              ? (_openBlock(), _createBlock(_component_ion_spinner, {
                                  key: 1,
                                  slot: "start"
                                }))
                              : _createCommentVNode("", true),
                            ($setup.isFormQuestionTask(task) && !$setup.loadingUserFormResponses)
                              ? (_openBlock(), _createBlock(_component_ion_icon, {
                                  key: 2,
                                  slot: "start",
                                  icon: $setup.isSubmittedTaskForm(task, $props.ev) ? $setup.checkmarkCircle : $setup.alertCircle,
                                  color: $setup.isSubmittedTaskForm(task, $props.ev) ? 'success' : 'danger'
                                }, null, 8, ["icon", "color"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createElementVNode("h3", null, [
                                  _createElementVNode("b", null, _toDisplayString(task.title), 1)
                                ]),
                                _createElementVNode("small", null, _toDisplayString(task.group), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["detail", "onClick"]))
                      }), 128)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.anchorEventTasks.filter(t => t.anchorEventId == $props.ev.anchorEventId && t.showAfterAttended && t.group == 'After Lesson' && (!$setup.isFormQuestionTask(t) || $setup.getFilteredFormQuestions(t).length > 0)), (task) => {
                        return (_openBlock(), _createBlock(_component_ion_item, {
                          key: task.id,
                          lines: "full",
                          button: "",
                          detail: $setup.checkShowTaskDetailIcon(task, $props.ev),
                          onClick: _withModifiers(($event: any) => ($setup.checkOpenTaskModal(task, $props.ev)), ["stop"]),
                          color: $setup.isSubmittedTaskForm(task, $props.ev) ? 'success' : 'light'
                        }, {
                          default: _withCtx(() => [
                            ($setup.isFormQuestionTask(task) && $setup.loadingUserFormResponses)
                              ? (_openBlock(), _createBlock(_component_ion_spinner, {
                                  key: 0,
                                  slot: "start"
                                }))
                              : _createCommentVNode("", true),
                            ($setup.isFormQuestionTask(task) && !$setup.loadingUserFormResponses)
                              ? (_openBlock(), _createBlock(_component_ion_icon, {
                                  key: 1,
                                  slot: "start",
                                  class: _normalizeClass({ 'icon-xxl': $setup.isFeedbackForm(task) && $setup.isSubmittedTaskForm(task, $props.ev) }),
                                  icon: $setup.isSubmittedTaskForm(task, $props.ev) ? $setup.checkmarkCircle : $setup.alertCircle,
                                  color: $setup.isSubmittedTaskForm(task, $props.ev) ? undefined : 'danger'
                                }, null, 8, ["class", "icon", "color"]))
                              : _createCommentVNode("", true),
                            ($setup.isFeedbackForm(task) && $setup.isSubmittedTaskForm(task, $props.ev))
                              ? (_openBlock(), _createBlock(_component_ion_label, { key: 2 }, {
                                  default: _withCtx(() => _cache[24] || (_cache[24] = [
                                    _createElementVNode("h1", null, [
                                      _createElementVNode("b", null, "Feedback form filled")
                                    ], -1)
                                  ])),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(_component_ion_label, { key: 3 }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("h3", null, [
                                      _createElementVNode("b", null, _toDisplayString(task.title), 1)
                                    ]),
                                    _createElementVNode("small", null, _toDisplayString(task.group), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                          ]),
                          _: 2
                        }, 1032, ["detail", "onClick", "color"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ], 512), [
                [_vShow, $props.ev.group == 'ABS' || $props.ev.userResponse?.confirmed == 'Yes']
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]))
}